<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <template slot="header">
        <i class='fa fa-align-justify'></i> Mail List
      </template>
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Registed_at
                <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_Category">Level</label>
              <v-select v-model="so.opt['mail_level']" :options="codes.MAIL_LEVEL"></v-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_Target">Target</label>
              <v-select v-model="so.opt['target']" :options="codes.MAIL_TARGET"></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <label for="opt_Title">Title</label>
            <b-input v-model="so.opt['title']" @keyup.enter="refresh"></b-input>
          </b-col>
          <b-col md="6">
            <label for="opt_description">description</label>
            <b-input v-model="so.opt['description']" @keyup.enter="refresh"></b-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <label for="opt_Content">Content</label>
            <b-input v-model="so.opt['content']" @keyup.enter="refresh"></b-input>
          </b-col>
          <b-col md="6">
            <label for="ph_search_opt_type">Partner Name</label>
            <b-button variant="primary" @click="chainPartner = true">Select Partner</b-button>
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="partner_name">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->
      <hr>
      <b-row>
        <b-col sm="2" v-if="view_detail !== false">
          <b-badge variant="primary">
            TOTAL : {{model.enable + model.disable}}
          </b-badge>
          <br>
          <b-badge variant="success">
            USE : {{model.enable}}
          </b-badge>
          <br>
          <b-badge variant="warning">
            Deleted : {{model.disable}}
          </b-badge>
        </b-col>

        <b-col :sm="view_detail !== false ? 10 : 12" class="md-10">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='title';so.skt='Title'">Title</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
          <br>
          <b-input-group size="sm">
            <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="auto_refresh" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
            <div>
              <b-button v-if="enable_new !== false" size="sm" variant="success" @click="$router.push({ name: 'mail', params: { id : 'add' } })"> New Registration </b-button>
            </div>
          </b-input-group>
        </b-col>

      </b-row>
      <hr>
      <b-tooltip class="w-100" block target="tooltip-target-1" triggers="hover">
        Category : Categorize of mail
        <br>
        Target : who can get received of mail
        <br>
        Title : title of mail
      </b-tooltip>
      <!-- :busy="is_loading" -->
      <b-table id="tooltip-target-1"  triggers="hover" striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <!-- <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime }}</template> -->
        <template slot="is_alive" slot-scope="row">
            <span @click="item = row.item; confirm = true">
              <c-switch color="success" label size="sm" v-model="row.item.is_alive"  />
            </span>
            <!-- <b-badge v-if="row.item.is_del" variant="danger">Disable</b-badge>
            <b-badge v-else variant="success">Enable</b-badge> -->
        </template>
        <template slot="level" slot-scope="row">{{row.item.level}}</template>
        <template slot="target" slot-scope="row">{{row.item.target ? row.item.target.length : 0}}</template>

        <template slot="title" slot-scope="row">
          <del v-if="!row.item.is_alive">
            <span style="cursor: pointer;" class="font-weight-bold" @click="detail(row.item)">{{row.item.title}}</span>
          </del>
          <template v-else>
            <span style="cursor: pointer;" class="font-weight-bold" @click="detail(row.item)">{{row.item.title}}</span>

          </template>
        </template>

        <template slot="updated_at" slot-scope="row">{{row.item.created_at | datetime }}</template>

        <!-- <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">Select</b-btn>
        </template> -->
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
      </b-row>
    </b-card>
    <!-- start modal -->
    <b-modal title="Find then Group and Select" size="xl"  header-bg-variant="info" v-model="chainPartner" @ok="chainPartner = false" ok-variant="info">
      <partner-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></partner-List>
    </b-modal>
    <!-- start modal -->
    <b-modal title="Confirm" size="sm"  header-bg-variant="info" v-model="confirm" hide-footer>
      <p>
        Are you sure change template status ?
      </p>
      <hr>
      <b-button class="mt-3" variant="outline-info" block @click="toggle(); confirm = false">OK</b-button>
      <b-button class="mt-2" variant="outline-warning" block @click="item.is_alive = !item.is_alive; confirm = false">Cancel</b-button>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/custom';
import { Api } from '@/service';
import custom from '@/custom';
import codes from '@/codes';
import vSelect from 'vue-select';
import PartnerList from '../../Management/partner/Partner.List';
import { Switch as cSwitch } from '@coreui/vue';

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

export default {
  components: { DatePicker, vSelect, PartnerList, cSwitch },
  props : ["auto_refresh", "enable_new", "view_detail"],
  name : "MailList",
  data: () => ({
    partner_name : '',
    chainPartner : false,
    custom,
    codes,
    datepicker,
    so : default_opt(),
    model : { total : 0, enable : 0, disable : 0 },
    sync : { interval : 15, stop : false, th : undefined },
    is_loading : true,
    item : {},
    confirm : false
  }),
  filters: {
    level(v) {
      return v;
    }
  },
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      let f = [
        { key: 'id', thStyle: 'width: 5%', sortable: true, label: 'No.' },
        // { key: 'created_at', thStyle: 'width: 10%', sortable: true, label: 'Registed_at' },
        { key: 'is_alive', thStyle: 'width: 10%', sortable: false, label: 'Status' },
        { key: 'cmd', thStyle: 'width: 10%', sortable: false, label: 'Cmd'},
        { key: 'level', thStyle: 'width: 10%', sortable: false, label: 'Level'},
        // { key: 'target', thStyle: 'width: 10%', sortable: false, label: 'Target' },
        { key: 'title', sortable: false, label: 'Title' },
        { key: 'updated_at', thStyle: 'width: 15%', sortable: true, label: 'Last updated' },
        // { key: 'func', sortable: false, label: 'More' },
      ]
      // if(this.user) { f.splice(1, 1) }
      return f;
    }
  },
  methods: {
    async toggle() {
      // 모달 확인 필요할 수 있음
      let model = Object.assign({}, this.item)
      delete model.category_code
      delete model.target_code
      // model.is_alive = !model.is_alive


      try{
        let rs = await Api.Manager_Call('mail', 'update', model);
        if(!rs.error) {
          // this.$toastr.s('Saved', this.$route.name);
          if(!this.model.id) { this.refresh(rs.body.id); }
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) }

    },
    setGroup(item) {
      console.log("partner info", item.username, item.id)
      this.so.opt['partner_id'] = item.id
      this.partner_name = item.username;
      this.chainPartner = false;
      this.refresh()
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'permissions') {
        return { name : k, value : v, op : '=' };
      } else if(['partner_id', 'category_code', 'target_code'].indexOf(k) > -1) {
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.th) { clearTimeout(this.th); this.th = undefined; }
      if(!this.th && this.sync.stop) { this.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      let so = {
        target : 'mail', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [{ name : 'is_del', value : false, op : '='}] },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_del':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'level':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'target':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.e("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.e("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'last_visit_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.e("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'last_visit_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.e("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return Api.Manager(so).then(rs => {
        // rs.body && rs.body.forEach(r =>
        //   codes.target.map(t => { t.meta.value == r.target_code ? r.target_code = t.name : '' }) &&
        //     codes.MAIL_level.map(c => { c.meta.value == r.category_code ? r.category_code = c.name : '' })
        // );
        this.so.totalRows = rs.total;
        return rs.body;
      }).catch(e => {
        console.log(e)
        this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
      });
    },
    summary() {
      Api.Manager({ target : 'mail', cmd : 'summary', body : { ts : new Date().getTime() } })
        .then(rs => { this.model = Object.assign(this.model, { enable : rs.body.enable, disable : rs.body.disable }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail(item) {

      if(this.view_detail === false) { this.$emit("select", item); }
      else {
        this.$router.push({ name : 'mail', params : { id : item.id } });
      }
    },
  },
  created() { console.log('Mail_list.vue', 'created'); },
  destroyed() { console.log('Mail_list.vue', 'destroyed'); },
  mounted() {
    console.log('Mail_list.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}
</script>
